import { createFileRoute } from '@tanstack/react-router'
import ComodidadesPage from '@/pages/dashboard/comodidades-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/comodidades',
)({
  component: function ComodidadesRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule 
        anyOf={[MODULES.IMOVEIS, MODULES.EMPREENDIMENTOS]} 
        dashboardId={dashboardId}
      >
        <ProtectedRoute capability={CAPABILITIES.EDIT_IMOB_DATA}>
          <ComodidadesPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
